const drawerWidth = '200px'
    export const LogoStyles = {
        maxWidth: "50px",
        marginRight: (theme) => theme.spacing(2)
    }
    export const BoxStyles = {
        padding: (theme) => theme.spacing(2),
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        textAlign: "center"
    }
    export const NavigationStyles = {
        display: "flex"
    }
    export const AppBarStyles = {
        backgroundColor: "primary.main",
        zIndex: 1400
    }
    export const AppBarShiftStyles = {
        zIndex: 1400
    }
    export const ApplicationNameStyles = {
        flexGrow: 1
    }
    export const HideStyles = {
        display: "none"
    }
    export const DrawerStyles = {
        flexShrink: 0
    }
    export const DrawerPaperStyles = {
        height: "100vh"
    }
    export const DrawerHeaderStyles = (theme) => ({
        width: '100%',
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(0, 2),
        justifyContent: "space-between",
        ...theme.mixins.toolbar,
    });
    export const ContentStyles = {
    flexGrow: 1,
    padding: (theme) => theme.spacing(3),
    transition: (theme) =>
        theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
        }),
    marginRight: -drawerWidth,
    };
    export const ContentShiftStyles = (theme) => ({
    transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
    });
    export const bottomPushStyles = {
        maxWidth: "190px",
        position: "fixed",
        bottom: 0,
        paddingBottom: 10
    }
    export const chipStyles = {
        color: "white",
        "& .MuiChip-icon": { color: "white" }
    }
